export interface IndexedMetadataEntry {
  name: string
  id: number
}

export function buildIndexedNameArray(entries: IndexedMetadataEntry[]): string[] | null {
  if (entries.length === 0) {
    return null
  }

  let maxId = 0
  for (const entry of entries) {
    if (entry.id > maxId) {
      maxId = entry.id
    }
  }

  const result: string[] = new Array(maxId + 1).fill('')

  for (const entry of entries) {
    if (entry.id < 0) {
      continue
    }
    result[entry.id] = entry.name
  }

  return result
}
